module.exports = __webpack_public_path__ + "img/LinkedIn.c78f9f31.svg";